import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showAlert } from "../../store/actions/AppAction";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import TextsmsIcon from "@material-ui/icons/Textsms";
import {
  getContestacoes,
  contestaPreFatura
} from "../../services/FaturamentoService";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  inline: {
    display: "inline"
  },
  rootInput: {
    color: "rgba(0, 0, 0, 0.87)",
    cursor: "text",
    display: "block",
    fontSize: "1rem",
    boxSizing: "border-box",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    lineHeight: "1.18em",
    alignItems: "center"
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

class Contestar extends React.Component {
  state = { justificativa: "", justificativas: [] };

  handleClose = () => {
    this.props.close();
  };

  onChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  salvarJustificativa = () => {
    contestaPreFatura(this.props.fatura, this.state.justificativa)
      .then(result => {
        this.props.showAlert({
          message: "O seu questionamento foi salvo!",
          options: {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "center" }
          }
        });
        this.props.getFatura();
      })
      .catch(error => {
        if (error.message) {
          this.props.showAlert({
            message: error.message,
            options: {
              variant: "error",
              anchorOrigin: { vertical: "top", horizontal: "center" }
            }
          });
        }
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.fatura && this.props.fatura !== prevProps.fatura) {
      this.getQuestionamentos(this.props.fatura);
    }
  }

  getQuestionamentos = fatura => {
    getContestacoes(fatura)
      .then(result => {
        this.setState({
          justificativas: result.data
        });
      })
      .catch(error => {
        this.setState({
          justificativas: []
        });
        console.log(error);
      });
  };

  render() {
    const { classes, isEnableContestar, perfilUsuario } = this.props;
    return (
      <Dialog
        fullWidth
        maxWidth={"lg"}
        onClose={this.handleClose}
        aria-labelledby="customized-dialog-title"
        open={this.props.open}
      >
        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
          {isEnableContestar && perfilUsuario === 3
            ? "Contestar Faturamento"
            : "Responder"}
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            InputProps={{
              className: classes.rootInput
            }}
            inputProps={{
              maxLength: 1000
            }}
            fullWidth
            label={perfilUsuario === 3 ? "Justificativa" : "Resposta"}
            placeholder={
              perfilUsuario === 3
                ? "Digite aqui sua justificativa"
                : "Digite aqui sua resposta"
            }
            name="justificativa"
            multiline
            rowsMax="20"
            value={this.state.justificativa}
            onChange={this.onChange}
            className={classes.textField}
            margin="normal"
          />

          <List className={classes.root}>
            {this.state.justificativas &&
              Object.keys(this.state.justificativas).length > 0 &&
              this.state.justificativas.map((just, i) => {
                return (
                  <React.Fragment>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <Avatar>
                          <TextsmsIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={just.FahiData}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              max
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {just.UsuaNome} (
                              {just.PerfilCodigo === 3
                                ? "Gestor Órgão"
                                : "Unidata"}
                              )
                            </Typography>
                            {" - " + just.FahiDescricao}
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    {i < Object.keys(this.state.justificativas).length - 1 && (
                      <Divider variant="inset" component="li" />
                    )}
                  </React.Fragment>
                );
              })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.salvarJustificativa} color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showAlert }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(Contestar));
